(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-product-informationS"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('nf-product')) return;

    class NFProduct extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        this.busy = false;
        this.index = 0;
        this.lock = 0;
        this.init();
      }

      disconnectedCallback() {
        this.ac?.abort();
        this.io?.disconnect();
        document.documentElement.style.overflow = '';
      }

      $(sel) { return this.querySelector(sel); }
      $$(sel) { return [...this.querySelectorAll(sel)]; }

      init() {
        const signal = this.ac.signal;
        this.slides = this.$$('[data-nf-slide]');
        this.navBtns = this.$$('[data-nf-nav]');
        this.viewport = this.$('[data-nf-viewport]');
        this.variants = JSON.parse(this.$('[data-nf-variants]')?.textContent || '[]');
        this.idInput = this.$('[data-nf-id]');
        this.atc = this.$('[data-nf-atc]');
        this.errEl = this.$('[data-nf-error]');
        this.priceEl = this.$('[data-nf-price]');
        this.groups = this.$$('[data-nf-group]');
        this.sizePos = Number(this.dataset.sizePosition) || 0;
        this.mq = window.matchMedia('(max-width: 767px)');

        /* ---------- Gallery ---------- */
        this.navBtns.forEach((b) =>
          b.addEventListener('click', () => this.goTo(Number(b.dataset.index)), { signal })
        );
        this.initScrollSync();
        this.fitHeight();
        window.addEventListener('resize', () => this.fitHeight(), { signal });
        window.addEventListener('load', () => this.fitHeight(), { signal });

        /* ---------- Accordions ---------- */
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-nf-acc-btn]');
          if (btn && this.contains(btn)) this.toggle(btn, btn.nextElementSibling);
        }, { signal });

        /* ---------- Size panel ---------- */
        const sizeToggle = this.$('[data-nf-size-toggle]');
        this.sizePanel = this.$('[data-nf-size-panel]');
        sizeToggle?.addEventListener('click', () => this.toggle(sizeToggle, this.sizePanel), { signal });

        /* ---------- Variants ---------- */
        this.groups.forEach((g) =>
          g.addEventListener('change', (e) => {
            const isSize = Number(g.dataset.position) === this.sizePos;
            this.clearError();
            this.updateVariant({ fromChange: true });
            if (isSize && e.target.checked) this.toggle(sizeToggle, this.sizePanel, false);
          }, { signal })
        );
        this.updateVariant({ initial: true });

        /* ---------- Add to cart ---------- */
        this.$('[data-nf-form]')?.addEventListener('submit', (e) => {
          e.preventDefault();
          this.addToCart();
        }, { signal });

        /* ---------- Lightbox ---------- */
        this.initLightbox(signal);
      }

      /* ===== Gallery ===== */
      fitHeight() {
        if (!this.viewport) return;
        if (this.mq.matches || this.dataset.fit !== 'true') {
          this.viewport.style.height = '';
          return;
        }
        const top = this.viewport.getBoundingClientRect().top + window.scrollY;
        const pb = parseFloat(getComputedStyle(this).paddingBottom) || 0;
        this.viewport.style.height = `${Math.max(420, Math.round(window.innerHeight - top - pb))}px`;
      }

      initScrollSync() {
        if (!this.viewport || !('IntersectionObserver' in window)) return;
        this.ratios = new Map();
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => this.ratios.set(e.target, e.intersectionRatio));
          if (performance.now() < this.lock) return;
          this.pickActive();
        }, { root: this.viewport, threshold: [0, 0.1, 0.25, 0.4, 0.5, 0.6, 0.75, 0.9, 1] });
        this.slides.forEach((s) => this.io.observe(s));
      }

      pickActive() {
        let best = this.index;
        let bestVal = -1;
        this.slides.forEach((s, i) => {
          const r = this.ratios.get(s) ?? 0;
          if (r > bestVal + 0.001) { bestVal = r; best = i; }
        });
        if (best !== this.index) { this.index = best; this.syncNav(); }
      }

      syncNav() {
        this.navBtns.forEach((b, i) => {
          if (i === this.index) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
      }

      goTo(i, instant = false) {
        if (!this.slides.length || !this.viewport) return;
        this.index = Math.max(0, Math.min(this.slides.length - 1, i));
        this.syncNav();
        this.lock = performance.now() + 800;
        const slide = this.slides[this.index];
        const horizontal = this.mq.matches;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({
          top: horizontal ? 0 : slide.offsetTop,
          left: horizontal ? slide.offsetLeft : 0,
          behavior: instant || reduce ? 'auto' : 'smooth',
        });
        clearTimeout(this.lockTimer);
        this.lockTimer = setTimeout(() => { this.lock = 0; this.pickActive(); }, 850);
      }

      /* ===== Collapsibles ===== */
      toggle(btn, panel, force) {
        if (!btn || !panel) return;
        const open = typeof force === 'boolean' ? force : btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        panel.dataset.open = String(open);
        const inner = panel.querySelector('.nf-collapse__inner');
        if (inner) inner.inert = !open;
      }

      /* ===== Variants ===== */
      selectedOptions() {
        const out = [];
        this.groups.forEach((g) => {
          const checked = g.querySelector('input:checked');
          out[Number(g.dataset.position) - 1] = checked ? checked.value : null;
        });
        return out;
      }

      findVariant(sel) {
        if (!sel.length || sel.some((v) => v === null || v === undefined)) return null;
        return this.variants.find((v) => v.options.every((o, i) => o === sel[i])) || null;
      }

      refreshAvailability(sel) {
        this.groups.forEach((g) => {
          const pos = Number(g.dataset.position) - 1;
          g.querySelectorAll('input').forEach((input) => {
            const ok = this.variants.some(
              (v) =>
                v.available &&
                v.options[pos] === input.value &&
                v.options.every((o, i) => i === pos || sel[i] === null || sel[i] === undefined || sel[i] === o)
            );
            input.disabled = !ok && !input.checked;
          });
        });
      }

      updateVariant({ initial = false, fromChange = false } = {}) {
        const sel = this.selectedOptions();
        this.refreshAvailability(sel);

        let variant = this.findVariant(sel);
        if (!this.groups.length) variant = this.variants[0] || null;

        const sizeLabel = this.$('[data-nf-size-label]');
        if (sizeLabel && this.sizePos) {
          const v = sel[this.sizePos - 1];
          sizeLabel.textContent = v ? `${this.dataset.labelSizeSelected}: ${v}` : this.dataset.labelSize;
        }

        if (this.idInput) this.idInput.value = variant ? variant.id : '';

        if (variant) {
          if (this.priceEl) {
            this.priceEl.innerHTML =
              (variant.compare ? `<s class="nf-price__compare">${variant.compare}</s>` : '') +
              `<span>${variant.price}</span>`;
          }
          if (fromChange && variant.media) {
            const idx = this.slides.findIndex((s) => Number(s.dataset.mediaId) === variant.media);
            if (idx > -1) this.goTo(idx);
          }
          if (!initial) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
        this.setButton(variant, sel);
      }

      setButton(variant, sel) {
        if (!this.atc || this.busy) return;
        const d = this.dataset;
        const complete = sel.length && sel.every((v) => v !== null && v !== undefined);
        if (variant && !variant.available) {
          this.atc.disabled = true;
          this.atc.textContent = d.labelSoldOut;
        } else if (!variant && complete) {
          this.atc.disabled = true;
          this.atc.textContent = d.labelUnavailable;
        } else {
          this.atc.disabled = false;
          this.atc.textContent = d.labelAdd;
        }
      }

      showError(msg) { if (this.errEl) { this.errEl.textContent = msg; this.errEl.hidden = false; } }
      clearError() { if (this.errEl) { this.errEl.textContent = ''; this.errEl.hidden = true; } }

      /* ===== Cart ===== */
      async addToCart() {
        if (this.busy) return;
        const sel = this.selectedOptions();
        const variant = this.groups.length ? this.findVariant(sel) : this.variants[0];

        if (!variant) {
          this.showError(this.dataset.errSelect);
          const toggle = this.$('[data-nf-size-toggle]');
          if (toggle) { this.toggle(toggle, this.sizePanel, true); this.sizePanel.querySelector('input:not(:disabled)')?.focus(); }
          return;
        }
        if (!variant.available) return;

        this.busy = true;
        this.clearError();
        this.atc.disabled = true;
        this.atc.setAttribute('aria-busy', 'true');
        this.atc.textContent = this.dataset.labelLoading;
        const root = window.Shopify?.routes?.root || '/';

        try {
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || this.dataset.errGeneric);
          await this.afterAdd(variant, root);
        } catch (err) {
          this.showError(err.message || this.dataset.errGeneric);
        } finally {
          this.busy = false;
          this.atc.removeAttribute('aria-busy');
          this.setButton(variant, sel);
        }
      }

      async afterAdd(variant, root) {
        if (this.dataset.afterAdd === 'redirect') {
          window.location.href = `${root}cart`;
          return;
        }
        let cart = null;
        try { cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json(); } catch (e) { /* ignore */ }

        const detail = {
          source: 'nf-product',
          itemCount: cart?.item_count,
          variantId: String(variant.id),
          productId: this.dataset.productId,
        };
        let dispatched = false;
        try {
          const mod = await import('@theme/events');
          if (mod?.CartAddEvent) {
            document.dispatchEvent(new mod.CartAddEvent(cart || {}, this.dataset.sectionId, detail));
            dispatched = true;
          }
        } catch (e) { /* not available in this theme */ }

        if (!dispatched) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: this.dataset.sectionId, data: detail },
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
        }

        const drawer = document.querySelector('cart-drawer-component, cart-drawer');
        if (drawer) {
          if (typeof drawer.open === 'function') drawer.open();
          else if (typeof drawer.show === 'function') drawer.show();
        }
      }

      /* ===== Lightbox (click an image) ===== */
      initLightbox(signal) {
        const dlg = this.$('[data-nf-lightbox]');
        if (!dlg || !this.viewport) return;
        const img = dlg.querySelector('[data-nf-lb-img]');
        const count = dlg.querySelector('[data-nf-lb-count]');
        const images = () => this.slides.map((s, i) => ({ s, i })).filter(({ s }) => s.dataset.type === 'image');
        let pos = 0;
        let lastFocus = null;

        const render = () => {
          const list = images();
          if (!list.length) return;
          pos = (pos + list.length) % list.length;
          const { s } = list[pos];
          img.src = s.dataset.zoomSrc;
          img.alt = s.dataset.zoomAlt || '';
          count.textContent = `${pos + 1} / ${list.length}`;
        };

        this.viewport.addEventListener('click', (e) => {
          const slide = e.target.closest('[data-nf-slide][data-type="image"]');
          if (!slide) return;
          const list = images();
          pos = Math.max(0, list.findIndex(({ s }) => s === slide));
          lastFocus = document.activeElement;
          render();
          document.documentElement.style.overflow = 'hidden';
          dlg.showModal();
          dlg.querySelector('[data-nf-lb-close]').focus();
        }, { signal });

        const close = () => { if (dlg.open) dlg.close(); };
        dlg.addEventListener('close', () => {
          document.documentElement.style.overflow = '';
          const list = images();
          if (list[pos]) this.goTo(list[pos].i, true);
          lastFocus?.focus?.();
        }, { signal });

        dlg.querySelector('[data-nf-lb-close]').addEventListener('click', close, { signal });
        dlg.querySelector('[data-nf-lb-prev]').addEventListener('click', () => { pos -= 1; render(); }, { signal });
        dlg.querySelector('[data-nf-lb-next]').addEventListener('click', () => { pos += 1; render(); }, { signal });
        dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); }, { signal });
        dlg.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { pos += 1; render(); }
          if (e.key === 'ArrowLeft') { pos -= 1; render(); }
        }, { signal });

        let sx = null;
        dlg.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') sx = e.clientX; }, { signal });
        dlg.addEventListener('pointerup', (e) => {
          if (sx === null) return;
          const dx = e.clientX - sx; sx = null;
          if (Math.abs(dx) > 50) { pos += dx < 0 ? 1 : -1; render(); }
        }, { signal });
      }
    }

    customElements.define('nf-product', NFProduct);
  })();

  } catch(e) { console.error(e); }
})();
})();
